import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { toast } from "sonner";
import { Card, StatusBadge, Modal, Field, Select, TextArea } from "./adminShared";
import { formatDate } from "@/lib/format";
import { Download } from "lucide-react";

export default function Inquiries() {
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(null);
  const [filter, setFilter] = useState("");

  const load = () => api.get("/admin/inquiries", { params: filter ? { status: filter } : {} }).then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const save = async () => {
    try {
      await api.patch(`/admin/inquiries/${sel.inquiry_id}`, { status: sel.status, notes: sel.notes });
      toast.success("Saved");
      setSel(null); load();
    } catch { toast.error("Failed to save"); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl text-earth" style={{ fontWeight: 600 }}>Enquiries</h1>
        <a href={`${API}/admin/inquiries/export.csv`} className="btn-outline text-sm" data-testid="export-inquiries"><Download size={16} className="mr-2" /> Export CSV</a>
      </div>
      <div className="flex gap-2 mb-4">
        {["", "new", "contacted", "converted", "closed"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-3 py-1.5 rounded-full text-sm font-semibold capitalize ${filter === s ? "bg-gold text-earth" : "bg-surface-card border hairline text-earth/60"}`}>{s || "All"}</button>
        ))}
      </div>
      {!items ? <p className="text-earth/50">Loading…</p> : items.length === 0 ? <p className="text-earth/50">No enquiries.</p> : (
        <Card className="overflow-hidden">
          <div className="divide-y divide-hairline">
            {items.map((it) => (
              <button key={it.inquiry_id} onClick={() => setSel({ ...it })} className="w-full text-left p-4 hover:bg-parchment transition-colors flex justify-between items-start gap-4" data-testid={`inquiry-${it.inquiry_id}`}>
                <div className="min-w-0">
                  <p className="font-semibold text-earth">{it.name} <span className="text-earth/40 font-normal">· {it.interest}</span></p>
                  <p className="text-sm text-earth/60 truncate">{it.message}</p>
                  <p className="text-xs text-earth/40 mt-1">{it.email} · {it.phone} · {formatDate(it.createdAt)}</p>
                </div>
                <StatusBadge status={it.status} />
              </button>
            ))}
          </div>
        </Card>
      )}

      {sel && (
        <Modal title="Enquiry" onClose={() => setSel(null)}>
          <div className="space-y-1 text-sm text-earth/80">
            <p><strong>{sel.name}</strong></p>
            <p>{sel.email} · {sel.phone}</p>
            <p>Interested in: {sel.interest} · Prefers: {sel.preferredContact}</p>
            <p className="pt-2 whitespace-pre-wrap">{sel.message}</p>
          </div>
          <Field label="Status"><Select value={sel.status} onChange={(e) => setSel({ ...sel, status: e.target.value })} data-testid="inquiry-status"><option value="new">New</option><option value="contacted">Contacted</option><option value="converted">Converted</option><option value="closed">Closed</option></Select></Field>
          <Field label="Internal notes"><TextArea rows={3} value={sel.notes || ""} onChange={(e) => setSel({ ...sel, notes: e.target.value })} data-testid="inquiry-notes" /></Field>
          <button onClick={save} className="btn-gold w-full" data-testid="inquiry-save">Save</button>
        </Modal>
      )}
    </div>
  );
}
